import React from "react";
import { i18n } from "../../translate/i18n";

const ContactDrawerSkeleton = () => {
  return (
    <div className="flex-1 overflow-y-auto bg-dark-100 dark:bg-dark-800 p-4">
      {/* Contact Header */}
      <div className="bg-white dark:bg-dark-900 rounded-lg border border-dark-200 dark:border-dark-700 p-6 flex flex-col items-center">
        {/* Avatar skeleton */}
        <div className="w-40 h-40 rounded-full bg-dark-200 dark:bg-dark-700 animate-pulse mb-4" />

        {/* Name skeleton */}
        <div className="h-5 w-24 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" />

        {/* Phone skeleton */}
        <div className="h-4 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-4" />

        {/* Button skeleton */}
        <div className="h-9 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
      </div>

      {/* Extra Info Section */}
      <div className="bg-white dark:bg-dark-900 rounded-lg border border-dark-200 dark:border-dark-700 p-4 mt-4">
        <h3 className="text-sm font-semibold text-dark-900 dark:text-white mb-3">
          {i18n.t("contactDrawer.extraInfo")}
        </h3>

        {[1, 2, 3].map((item) => (
          <div
            key={item}
            className="bg-dark-50 dark:bg-dark-800 rounded border border-dark-200 dark:border-dark-700 p-3 mb-2"
          >
            <div className="h-3 w-16 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" />
            <div className="h-4 w-36 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactDrawerSkeleton;
